import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { styled } from '@mui/material/styles';
import { Chip } from '@mui/material';

const StatusLabel = ({ status }) => {
  const { t } = useTranslation();

  const statusMap = {
    active: {
      color: 'success',
    },
    inactive: {
      color: 'warning',
    },
    disabled: {
      color: 'error',
    },
  };

  const { color } = statusMap[status] || { color: 'default' };

  return <Chip label={t(status, { defaultValue: status })} color={color} size="small" sx={{ borderRadius: '16px' }} />;
};

StatusLabel.propTypes = {
  status: PropTypes.string.isRequired,
};

export default StatusLabel;
